
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"red"}}),_c('g',{attrs:{"clip-path":"url(#clip0_3175_518)","fill":"#fff"}},[_c('path',{attrs:{"d":"M10.586 30H21.21a.586.586 0 00.586-.586v-.625c0-.647-.525-1.172-1.172-1.172v-.7c0-.928-.755-1.683-1.682-1.683h-6.089c-.927 0-1.682.755-1.682 1.683v.7c-.647 0-1.172.525-1.172 1.172v.625c0 .323.262.586.586.586zM17.333 22.904a1.172 1.172 0 101.872-1.41l-3.526-4.68a1.172 1.172 0 10-1.872 1.41l3.526 4.68zM25.756 16.557a1.172 1.172 0 001.872-1.41l-3.526-4.68a1.172 1.172 0 10-1.872 1.41l3.526 4.68zM23.186 19.96a6.354 6.354 0 001.923-2.315L21.006 12.2a6.356 6.356 0 00-2.757 1.21 6.354 6.354 0 00-1.923 2.316l4.103 5.445a6.355 6.355 0 002.757-1.21zM24.768 20.114c-.273.278-.56.544-.877.783a7.924 7.924 0 01-.994.627l.764 1.014 1.871-1.41-.764-1.014zM26.238 22.064l-1.872 1.41 3.526 4.68a1.172 1.172 0 101.872-1.411l-3.526-4.68z"}})]),_c('path',{attrs:{"d":"M8.5 17.722L11.222 15l.778.778L9.278 18.5 12 21.222l-.778.778L8.5 19.278 5.778 22 5 21.222 7.722 18.5 5 15.778 5.778 15 8.5 17.722z","fill":"#fff"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3175_518"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    